import React, { useMemo } from "react";
import { Alert, Box, LinearProgress, Typography } from "@mui/material";
import { AppTab } from "components/common/tabs";
import { AppButton } from "components/common/buttons";

const ALL = "all";

// Build organization tabs from the catalog without preloading personnel.
export default function PersonnelOrganizationFilter({ departments, loading, error, onRetry, value, onChange, disabled = false, includeAll = true }) {
  const branches = useMemo(() => [...new Map(departments.map((department) => [
    department.enterpriseId,
    { value: department.enterpriseId, label: department.enterpriseName || `Đơn vị #${department.enterpriseId}` },
  ])).values()], [departments]);
  const branchDepartments = departments.filter((department) =>
    value.enterpriseId == null || department.enterpriseId === value.enterpriseId);

  return (
    <Box sx={{ mb: 2 }}>
      {loading && <LinearProgress aria-label="Đang tải cơ cấu tổ chức" />}
      {error && <Alert severity="error" action={<AppButton disabled={disabled} onClick={onRetry}>Thử lại</AppButton>}>{error}</Alert>}
      <Typography variant="body2" fontWeight={600}>Đơn vị</Typography>
      <AppTab aria-label="Lọc nhân sự theo chi nhánh" value={value.enterpriseId ?? (includeAll ? ALL : false)}
        tabs={[...(includeAll ? [{ value: ALL, label: "Tất cả chi nhánh" }] : []), ...branches].map((item) => ({ ...item, disabled: disabled || loading }))}
        onChange={(_, enterpriseId) => onChange({
          enterpriseId: enterpriseId === ALL ? null : enterpriseId,
          departmentId: includeAll ? null : departments.find((department) => department.enterpriseId === enterpriseId)?.departmentId ?? null,
        })} />
      <Typography variant="body2" fontWeight={600} sx={{ mt: 1.5 }}>Phòng ban</Typography>
      <AppTab aria-label="Lọc nhân sự theo phòng ban" value={value.departmentId ?? (includeAll ? ALL : false)}
        tabs={[
          ...(includeAll ? [{ value: ALL, label: "Tất cả phòng ban" }] : []),
          ...branchDepartments.map((department) => ({
            value: department.departmentId,
            label: `${department.departmentName}${value.enterpriseId == null ? ` (${department.enterpriseName || department.enterpriseId})` : ""}`,
          })),
          ...(includeAll && value.enterpriseId == null ? [{ value: 0, label: "Chưa phân phòng ban" }] : []),
        ].map((item) => ({ ...item, disabled: disabled || loading }))}
        onChange={(_, departmentId) => onChange({ ...value, departmentId: departmentId === ALL ? null : departmentId })} />
    </Box>
  );
}
